var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCalendarDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61719 20H28.6172",
    stroke: "#DAA34A",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61719 9.5H10.1172",
    stroke: "#13123A",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61719 13H10.1172",
    stroke: "#13123A",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61719 17H10.1172",
    stroke: "#13123A",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6172 9.5H18.1172",
    stroke: "#13123A",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6172 13H18.1172",
    stroke: "#13123A",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6172 17H18.1172",
    stroke: "#13123A",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6172 9.5H26.1172",
    stroke: "#13123A",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6172 13H26.1172",
    stroke: "#13123A",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6172 17H26.1172",
    stroke: "#13123A",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.11719,
    y: 4.5,
    width: 28,
    height: 19,
    rx: 3.5,
    stroke: "#13123A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.11719,
    y: 0.5,
    width: 2,
    height: 6,
    rx: 1,
    fill: "white",
    stroke: "#13123A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1172,
    y: 0.5,
    width: 2,
    height: 6,
    rx: 1,
    fill: "white",
    stroke: "#13123A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1172,
    y: 0.5,
    width: 2,
    height: 6,
    rx: 1,
    fill: "white",
    stroke: "#13123A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarDark);
export default __webpack_public_path__ + "static/media/ic_calendar_dark.c403fdedb1898a489394ca083a8b37e2.svg";
export { ForwardRef as ReactComponent };